__turbopack_context__.v({
  "freeBox": "PlasmicDescription-module__sX9r_G__freeBox",
  "root": "PlasmicDescription-module__sX9r_G__root",
});
